export default (basketItem) => {
  if (window.start?.settings?.should_use_external_master_product_id) {
    return basketItem.externalProductId || basketItem.productId;
  }
  return '';
};
